import { graphql } from "react-relay";

export const ToggleJobStatusMutation = graphql`
  mutation ToggleJobStatusMutation($input: ToggleJobStatusInput!) {
    toggleJobStatus(input: $input) {
      job {
        id
        status
      }
    }
  }
`;